import { handleLongText, slugToTitleCase } from 'config/libraries';
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

export const Detail = ({response}) => {
    return (
        <div className="jl_single_style2">
            {
                (response != null) ?
                <Fragment>
                    <div className="single_post_entry_content single_bellow_left_align jl_top_single_title jl_top_title_feature">
                        <span className="meta-category-small single_meta_category">
                            <a className="post-category-color-text" style={{background: '#eba845'}} href="#">{slugToTitleCase(response.slug_galeri_foto)}</a>
                        </span>
                        <h1 className="single_post_title_main">{response.judul_galeri_foto}</h1>
                        <p className="post_subtitle_text">{response.deskripsi_galeri_foto}</p>
                        <span className="jl_post_meta">
                            <span className="jl_author_img_w">
                                <i className="jli-user" />{response.jumlah_foto} Foto
                            </span>
                            <span className="post-date">
                                <i className="jli-pen" />{response.created_at}
                            </span>
                            <span className="post-read-time">
                                <i className="jli-watch-2" />{response.total_hit}
                            </span>
                        </span>
                    </div>
                    <div className="post_content_w">
                        <div className="rows">
                            <div id="content_masonry" className="row">
                                {
                                    response.galeri_foto_item.map((item, index) => {
                                        return (
                                            <div className="col-md-6">
                                                <div key={index} className="box jl_grid_layout1 blog_grid_post_style post-2957 post type-post status-publish format-standard has-post-thumbnail hentry category-inspiration tag-morning">
                                                    <div className="jl_grid_w">
                                                        <div className="jl_img_box jl_radus_e">
                                                            <a href={process.env.REACT_APP_SERVER_IMAGE_URL + item.file_foto} alt={item.deskripsi_foto} target="_blank" rel='noreferrer'>
                                                                <img height={350} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.file_foto} className="attachment-sprasa_slider_grid_small size-sprasa_slider_grid_small wp-post-image image-size-fix-galeri" alt="" loading="lazy" />
                                                            </a>
                                                            <span className="jl_f_cat">
                                                                <Link to={'/galeri-foto/' + response.judul_galeri_foto} className="post-category-color-text" style={{background: '#91bd3a'}}>{ slugToTitleCase(response.slug_galeri_foto) }</Link>
                                                            </span>
                                                        </div>
                                                        <div className="text-box">
                                                            <h3>
                                                                {item.deskripsi_foto}
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </Fragment> : 'Loading ...'
            }
        </div>
    )
};